import { ChangeEvent, memo, useCallback, useEffect, useState, VFC } from "react";
import {
  Box,
  Button,
  Center,
  Flex,
  Input,
  InputGroup,
  InputLeftElement,
  Spinner,
  useDisclosure,
  Wrap,
  WrapItem
} from "@chakra-ui/react";
import { GroupCard } from "../../organisms/tenant/GroupCard";

import { useGroup } from "../../../hooks/useGroup";
import { GroupDetailModal } from "../../organisms/modal/GroupDetailModal";
import { Group } from "../../../types/api/group";
import { useUser } from "../../../hooks/useUser";
import { AddIcon, Search2Icon } from "@chakra-ui/icons";

export const Groups: VFC = memo(() => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { getGroups,groupAdd, groupEdit, groupDelete, loading, groups } = useGroup();
  const { getUsers, users } = useUser(onClose);

  const newGroup: Group = {
    tenant_id: "",
    group_id: "",
    title: "",
    description: "",
    users: [],
  };
  const [selectedGroup, setSelectedGroup] = useState<Group>(newGroup);
  const [searchValue, setSearchValue] = useState(""); 

  useEffect(() => getGroups(), [getGroups]);
  useEffect(() => getUsers(), [getUsers]);

  const onClickGroup = useCallback(
    (group_id: string) => {
      //      onSelectType({ typeName, types, dlType.onOpen });
      const targetGroup = groups.find((obj) => obj.group_id === group_id);
      if (targetGroup) {
        setSelectedGroup(targetGroup);
        onOpen();
      } else {
        setSelectedGroup(newGroup);
        onOpen();
      }
    },
    [groups, newGroup, onOpen]
  );

  const onChangeSearch = (e: ChangeEvent<HTMLInputElement>) =>{
    setSearchValue(e.target.value);
  }

  return (
    <>
      <Flex mx="5" my="2">
        グループを選択してください。
      </Flex>
      <Flex mx="5">
        <InputGroup>
          <InputLeftElement
            pointerEvents='none'
            children={<Search2Icon color='gray.300' />}
          />
          <Input value={searchValue} placeholder="search groupName or userID (email)" onChange={onChangeSearch} />
        </InputGroup>
      </Flex>
      {loading ? (
        <Center h="50vh">
          <Spinner color="teal.200" />
        </Center>
      ) : (
        <>
          <Flex px={{ base: 4, md: 10 }} py={{ base: 2, md: 4 }}>
            <Button leftIcon={<AddIcon />} colorScheme='teal' variant='solid' onClick={()=>onClickGroup("")}>
            新規登録
            </Button>        
          </Flex>
          <Wrap px={{ base: 4, md: 10 }} py={{ base: 1, md: 2 }}>
            {groups.filter(obj => {
                    return searchValue === "" ||
                          obj.title.indexOf(searchValue) >= 0 ||
                          obj.users.findIndex((userinfo)=>{return userinfo.userName.includes(searchValue)}) >= 0
                  }).map((obj) => (
              <WrapItem key={obj.group_id} mx="auto">
                <GroupCard
                  group_id={obj.group_id}
                  title={obj.title}
                  description={obj.description}
                  users_count={"ユーザー数：" + String(obj.users.length)}
                  onClick={onClickGroup}
                />
              </WrapItem>
            ))}
          </Wrap>
        </>
      )}
      <GroupDetailModal
        isOpen={isOpen}
        onInsert={groupAdd}
        onUpdate={groupEdit}
        onDelete={groupDelete}
        onClose={onClose}
        group={selectedGroup}
        tenantUsers={users}
      />
    </>
  );
});
